import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';

import { routes } from './app.routes';

const sentryEnabled = Boolean(environment.sentryDsn);

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		...(sentryEnabled
			? [
					{
						provide: ErrorHandler,
						useValue: Sentry.createErrorHandler()
					},
					{
						provide: Sentry.TraceService,
						deps: [Router]
					},
					{
						provide: APP_INITIALIZER,
						useFactory: () => () => undefined,
						deps: [Sentry.TraceService],
						multi: true
					}
				]
			: [])
	]
};
